import React from "react";
import { useStoredArray } from "../../../state/InternalContext";

interface ArrayLengthProps {
    array: string,
}

/***
 * A source component that returns the length of a stored array.
 * 
 * Params:
 *      name: The name of the store
 */
export const ArrayLength = React.memo(function ArrayLength({ array }: ArrayLengthProps): React.ReactElement {
    const storedArray = useStoredArray(array);
    return <>{storedArray?.length || 0}</>;
});